// packages/web/src/lib/auth/auth-guard.ts
// Route protection and authentication logic

import { getToken } from './session-manager';
import { isLikelyJwt, isStubToken } from './token-manager';

export function isAuthenticated(): boolean {
  const token = getToken();
  return !!(token && isLikelyJwt(token) && !isStubToken(token));
}

export function isAnonymousMarketplaceEndpoint(url: string, method: string = 'GET'): boolean {
  const path = url.replace(/^\/api(?=\/)/, '').split('?')[0];
  if (method.toUpperCase() !== 'GET' && method.toUpperCase() !== 'HEAD') return false;
  if (/^\/marketplace\/?$/i.test(path) || /^\/marketplace\/services\/?$/i.test(path)) return true;
  const detail = /^\/marketplace\/services\/([^/]+)(?:\/ai)?\/?$/i.exec(path);
  if (!detail) return false;
  try { return decodeURIComponent(detail[1]).toLowerCase() !== 'flagship'; }
  catch { return true; } // API Express decoder validates malformed input.
}

export function shouldAttachAuthHeader(url: string, method: string = 'GET'): boolean {
  const token = getToken();
  const isAnonymousEndpoint = isAnonymousMarketplaceEndpoint(url, method);

  return !!(token && isLikelyJwt(token) && !isStubToken(token) && !isAnonymousEndpoint);
}

export function getAuthHeader(): string | null {
  const token = getToken();
  if (shouldAttachAuthHeader('', 'GET')) { // Check general auth capability
    return `Bearer ${token}`;
  }
  return null;
}

export function requireAuth(): void {
  if (!isAuthenticated()) {
    if (typeof window !== 'undefined') {
      window.location.href = '/login';
    }
    throw new Error('Authentication required');
  }
}

export function redirectToLogin(): void {
  if (typeof window !== 'undefined') {
    window.location.href = '/login';
  }
}